import defaultParams from 'utils/calendar/defaultParams';

const userLocaleParams = {};

function getLocaleParams (key) {
  const custom = userLocaleParams[key];
  if (custom) {
    if (typeof custom === 'function') {
      return custom();
    }
    return custom;
  }

  if (!defaultParams[key]) {
    console.error(`Locale param [${key}] is not present`);
  }
  return defaultParams[key];
}

function setupLocaleParams (Vue, params = {}) {
  Object.keys(params).forEach(k => {
    userLocaleParams[k] = params[k];
  });

  Vue.prototype._getLocaleParams = getLocaleParams;
}

export default getLocaleParams;
export {setupLocaleParams};
